import React from 'react'

const Drinks = () => {
  return (
    <div className="pt-6">

    <h1 className="font-Bree text-white text-4xl ">SHAKES</h1>
    
     /*Vegetarian menu starts */
       <ul className="font-Monty text-white font-bold">
        <li><span className="px-4">COLD COFFEEEE</span> <span className="text-2xl">150-/-</span> </li>
        <li><span className="px-4">STRAWBERRY</span ><span className="text-2xl">160-/-</span> </li>
        <li><span className="px-4">HIDE & SEEK</span><span className="text-2xl">160-/-</span> </li>
        <li><span className="px-4">OREO</span> <span className="text-2xl">160-/-</span> </li>
        <li><span className="px-4">KIT-KAT</span><span className="text-2xl">170-/-</span> </li>
        <li><span className="px-4">HONEY BANANA SMOOTHIE</span> <span className="text-2xl">180-/-</span> </li>
        <li><span className="px-4">PEANUT PRO SMOOTHIE</span> <span className="text-2xl">180-/-</span> </li>
        <li><span className="px-4">STRAWBERRY SMOOTHIE</span> <span className="text-2xl">180-/-</span> </li>
        <li><span className="px-4">BERRIES & ALMOND SMOOTHIE</span> <span className="text-2xl">180-/-</span> </li>
       </ul>
     /*Vegetarian Menu Ends */
     
     
    
  </div>
  )
}

export default Drinks